import { PAGE_TITLE } from "./constant";

export const setDocumentTitle = (title: string) => {
  if (title) {
    // eslint-disable-next-line no-restricted-properties -- it's ok to use document.title here
    document.title = `${title} - ${PAGE_TITLE}`;
  } else {
    // eslint-disable-next-line no-restricted-properties -- it's ok to use document.title here
    document.title = PAGE_TITLE;
  }
};
